<template>
  <div id="app" class="f-14 pr"  :class="{'buybox':setfoot}">
    <heads></heads>
     <keep-alive>
        <router-view v-if="$route.meta.keepAlive" class="router-view" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router-view" />
    <!-- <router-view  class="router-view" /> -->
    <foots></foots>
    <!--二维码弹窗 -->
    <codes />
    <codes2 />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: 'App',
  data() {
    return {
      setfoot: false,
    };
  },
  computed: {
    ...mapState('cityList', ['cinemaInfo'])
  },
   mounted(){

    //  console.log(this.$store.state.cityList.cinemaInfo.cinemaCod)
     if(this.$store.state.cityList.cinemaInfo.cinemaCode==''){
      this.$router.push({ name: "index" });
     }
     
     this.setfoot1(); 
  },
        methods:{
          setfoot1: function() {//设置底部间距
              var h=window.location.href;
              if(h.indexOf('#/index')!=-1 ||
                h.indexOf('#/tickets/choose_order')!=-1 ||
                h.indexOf('#/tickets/shop_order')!=-1                 
              ){
                this.setfoot=true;
              }else{
                this.setfoot=false;
              }
            }
        },
        watch: {
            '$route': 'setfoot1',
        }
}
</script>

<style>
@import "assets/css/common.css";
@import "assets/css/style.css";
@import "assets/css/GY.css";
@import "assets/css/LZY.css";
@import "assets/css/ZZH.css";
</style>
  



// WEBPACK FOOTER //
// src/App.vue